import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Container, Flex, VStack, Heading, Text } from "@chakra-ui/react"
import Example from "./Example"

export default function ListItem({ node }) {
  return (
    <Container
      maxW={{ base: "704px", xl: "full" }}
      mt={{ base: 14, xl: 20 }}
      mb={{ base: 14, xl: 20 }}
      as="section"
    >
      <Flex
        layerStyle="foreground"
        direction={{ base: "column-reverse", xl: "row" }}
      >
        <Flex w={{ base: "full", xl: 1 / 3 }} direction="column">
          <Flex
            direction="column"
            bg="base.d100"
            flex={1}
            p={{ base: 6, xl: 12 }}
          >
            <VStack spacing={4} align="flex-start">
              <Heading
                fontWeight="semibold"
                alignSelf="center"
                textAlign="center"
                color="white"
                size="lg"
                letterSpacing="wide"
                as="h2"
              >
                {node.name}
              </Heading>

              <Text
                as="span"
                fontWeight="semibold"
                alignSelf="center"
                size="5xl"
                mt="auto"
                letterSpacing="wide"
                color="primary.200"
              >
                {node.price}
                <Text as="span" color="gray.200" size="xs">
                  &nbsp;inc VAT
                </Text>
              </Text>

              {node.paragraphs.map((str, index) => {
                return <Text key={index}>{str}</Text>
              })}
            </VStack>
            <Example heading={node.name} />
          </Flex>
        </Flex>
        <Flex w={{ base: "full", xl: 2 / 3 }} bg="base.d100">
          <GatsbyImage
            image={node.image.childImageSharp.gatsbyImageData}
            style={{ width: "100%" }}
          />
        </Flex>
      </Flex>
    </Container>
  )
}
